export default ({
    title: "芜湖诺康生物管理后台",
    name:"管理员",
    // gateway: "http://47.121.119.251:8082/live-app",
    gateway: "https://web.whnksw.com/api",


    basePath: '/',
    favicons: ['/'],
});